import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

interface IProps {
  isModalImage?: boolean
  disabledBorder?: boolean
  scanToEarnMode?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  mediaWrapper: (props: IProps) => ({
    '&&': {
      padding: props.disabledBorder ? 'auto' : props?.scanToEarnMode ? `20px` : `10px 20px 22px`,
      border: props.disabledBorder ? 'none' : `1px solid ${theme.palette.custom.grey}`,

      [theme.breakpoints.down('tablet')]: {
        width: '100%',
        borderRadius: '10px',
      },
      [theme.breakpoints.up('tablet')]: {
        borderRadius: '15px',
      },
    },
  }),
  cardTitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.medium,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,
      color: theme.palette.custom.grey2,
      display: 'flex',
      justifyContent: 'space-between',
    },
  },

  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },

  additionalSection: {
    border: `1px solid ${theme.palette.custom.grey}`,
    borderRadius: '5px',
    padding: '10px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  upperTitleWrapper: {
    '&&': {
      marginBottom: SPACES.xxxs,

      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  inputType: {
    '&&': {
      lineHeight: 1.33,

      color: theme.palette.custom.grey2,

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.s,
        fontWeight: FONTS.WEIGHTS.light,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xs,
        fontWeight: FONTS.WEIGHTS.medium,
      },
    },
  },
  inputFilesCount: {
    '&&': {
      marginBottom: SPACES.s,

      textTransform: 'capitalize',
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },
  imageItemWrapper(props: IProps) {
    return {
      height: '100%',

      [theme.breakpoints.down('tablet')]: {
        width: props.isModalImage ? 100 : 60,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 100,
      },
    }
  },
  dragDropArea() {
    return {
      opacity: 0,
      position: 'absolute',
      width: '30%',
      height: '100px',
      zIndex: '10',
      pointerEvents: 'none',
    }
  },
  imageWrapper(props: IProps) {
    return {
      '&&': {
        position: 'relative',

        [theme.breakpoints.down('tablet')]: {
          width: props.isModalImage ? 100 : 60,
          height: props.isModalImage ? 100 : 60,
        },
        [theme.breakpoints.up('tablet')]: {
          width: 100,
          height: 100,
        },
      },
    }
  },
  imageButton: {
    '&&': {
      padding: 0,
      width: 'inherit',
      height: 'inherit',
    },
  },
  imagesWrapper: (props: IProps) => ({
    [theme.breakpoints.down('tablet')]: {
      columnGap: SPACES.l,
      rowGap: props?.scanToEarnMode ? SPACES.l : SPACES.xxxxxxxl,
    },

    [theme.breakpoints.up('tablet')]: {
      columnGap: SPACES.xxxxxl,
      rowGap: props?.scanToEarnMode ? SPACES.xxxxxl : SPACES.xxxxxxxl,
    },
  }),
  imageIconWrapper(props: IProps) {
    return {
      '&&': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        borderRadius: 5,

        [theme.breakpoints.down('tablet')]: {
          width: props.isModalImage ? 100 : 60,
          height: props.isModalImage ? 100 : 60,

          border: `1px dashed ${theme.palette.custom.grey2}`,
        },

        [theme.breakpoints.up('tablet')]: {
          width: 100,
          height: 100,

          border: `2px dashed ${theme.palette.custom.grey2}`,
        },
      },
      '&&:hover': {
        backgroundColor: theme.palette.custom.grey,
      },
    }
  },
  imageIcon: {
    width: 24,
    height: 24,
  },
  image: {
    '&&': {
      display: 'block',

      borderRadius: 5,
      objectFit: 'cover',

      width: '100%',
      height: '100%',
      fill: theme.palette.custom.darkBlue2,
    },
  },

  imageMasked: {
    '&&': {
      filter: 'brightness(70%)',
    },
  },

  removeImageButton: {
    cursor: 'pointer',
    '&&': {
      position: 'absolute',
      top: -9,
      right: -9,

      padding: '0.2rem',
    },
  },
  previewButton: {
    cursor: 'grab',
    '&&': {
      position: 'absolute',
      top: -9,
      left: -9,

      padding: '0.2rem',
    },
  },
  removeImage: {
    '&&': {
      width: 20,
      height: 20,
    },
  },
  arrowButtonsWrapper: {
    '&&': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 10,
      opacity: 0,
      transition: 'opacity 0.3s ease',

      '&:hover': {
        opacity: 1,
      },

      [theme.breakpoints.down('tablet')]: {
        opacity: 1,
      },
    },
  },
  moveImageButton: {
    '&&': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',

      minWidth: 20,
      width: 35,
      height: 35,
      padding: 0,
      borderRadius: '50%',
      backgroundColor: theme.palette.custom.greyTransparent,
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 15,
      transition: 'background 0.3s ease',

      '&:hover': {
        backgroundColor: theme.palette.custom.grey,
      },

      [theme.breakpoints.down('tablet')]: {
        width: 25,
        height: 25,
      },
    },
  },
  moveImage: {
    '&&': {
      width: 25,
      height: 25,

      [theme.breakpoints.down('tablet')]: {
        width: 18,
        height: 18,
      },
    },
  },
  imageTitleWrapper: {
    width: 'inherit',
    height: 'auto',

    overflow: 'hidden',
    textAlign: 'center',
    wordBreak: 'break-word',
    wordWrap: 'break-word',
  },
  imageTitle: {
    '&&': {
      display: 'inherit',
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,
    },
  },
  warningText: {
    '&&': {
      marginTop: 3,

      fontSize: FONTS.SIZES.s,
      lineHeight: 1.4,
      color: theme.palette.custom.warning,
    },
  },
  modalWrapper: {
    '&&': {
      padding: SPACES.xxxl,
      overflowY: 'auto',

      width: '100%',
      maxWidth: '335px',
      maxHeight: 'calc(100vh - 100px)',

      display: 'flex',
      flexDirection: 'column',
    },
  },
  mediaForm: {
    width: '100%',
    height: 'fit-content',
    flex: 1,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: SPACES.xl,
  },
  modalTitle: {
    '&&': {
      fontSize: FONTS.SIZES.xl,
      fontWeight: FONTS.WEIGHTS.medium,
      lineHeight: 1.4,
    },
  },
  modalContentWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: SPACES.l,
  },
  modalImageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  linkIcon: {
    '&&': {
      width: 20,
      heigh: 20,
      color: theme.palette.custom.grey2,
    },
  },
  linkInputButton: {
    '&&': {
      padding: SPACES.xxxs,
    },
  },
  editActionWrapper: {
    '&&': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  editImageButton: {
    '&&': {
      position: 'absolute',
      top: 0,
      left: 5,
      transform: 'translateY(-105%)',
      padding: 4,

      [theme.breakpoints.down('tablet')]: {
        left: '-8px',
      },
    },
  },
  openImageButton: {
    '&&': {
      position: 'absolute',
      top: 0,
      right: 5,
      transform: 'translateY(-105%)',
      padding: 4,

      [theme.breakpoints.down('tablet')]: {
        right: '-8px',
      },
    },
  },
  editImage: {
    '&&': {
      width: 20,
      height: 20,

      [theme.breakpoints.down('tablet')]: {
        width: 18,
        height: 18,
      },
    },
  },
}))

export default useStyles
